export const INFO_PAGES = {
  termos: { titulo:'Termos de uso', html:`
    <p>Texto completo em <a href="/termos" target="_blank" rel="noopener">app.torredecontrole.org/termos</a>.</p>
    <p>A <b>Torre de Controle</b> agrega dados de Shopify e Meta para operação de tráfego. Confira números críticos nas plataformas oficiais antes de decidir orçamento.</p>` },
  privacidade: { titulo:'Privacidade', html:`
    <p>Tratamos dados conforme a política publicada em <a href="/privacidade" target="_blank" rel="noopener">app.torredecontrole.org/privacidade</a>.</p>
    <p>Dúvidas: <a href="mailto:gustavo@skylibs.com">gustavo@skylibs.com</a>.</p>` },
  contato: { titulo:'Contato', html:`
    <p>Dúvidas, sugestões ou problemas com o painel? Fale com o responsável pela operação de tráfego.</p>
    <p class="cell-sub">Torre de Controle · painel de tráfego pago</p>` }
};
